function scriptLoader(src, done, async, defer) {
    return new Promise(res => {
        if (typeof document !== 'undefined') {
            const js = document.createElement('script');
            if (async) {
                js.async = true;
            }
            if (defer) {
                js.defer = true;
            }
            js.src = src;
            js.onload = () => {
                if (typeof done === 'function') done();
                res();
            };

            js.onerror = () => {
                if (typeof done === 'function') {
                    done(new Error(`Failed to load script ${src}`));
                    res();
                }
            };
            document.head.appendChild(js);
        } else {
            if (typeof done === 'function') done();
            res();
        }
    });
}

export default scriptLoader;
